import { render, staticRenderFns } from "./Readygoods.vue?vue&type=template&id=6d5f56b6"
import script from "./Readygoods.vue?vue&type=script&lang=js"
export * from "./Readygoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports